import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout-dialog',
  templateUrl: './logout-dialog.component.html',
  styleUrls: ['./logout-dialog.component.scss']
})
export class LogoutDialogComponent implements OnInit {

  display: any;
  interval: any;

  constructor(public dialogRef: MatDialogRef<LogoutDialogComponent>,
    private router: Router,) {
      let currentUser = sessionStorage.getItem('userToken');
      if (currentUser != null && currentUser != undefined && currentUser != "") {
        this.timer(5);
        }
     }

    ngOnInit(): void {
     }
    
     timer(minute) {
      // let minute = 1;
      let seconds: number = minute * 60;
      let textSec: any = "0";
      let statSec: number = 60;
  
      const prefix = minute < 10 ? "0" : "";
  
      this.interval = setInterval(() => {

        let currentUser = sessionStorage.getItem('userToken');
        if (currentUser != null && currentUser != undefined && currentUser != "") {
          seconds--;
          if (statSec != 0) statSec--;
          else statSec = 59;
    
          if (statSec < 10) {
            textSec = "0" + statSec;
          } else textSec = statSec;
    
          this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
    
          if (seconds == 0) {
             this.ClickNo('N');
             clearInterval(this.interval);
          }
        }else{
          this.ClickNo('N');
          clearInterval(this.interval);
        }
      
      }, 1000);
    }
  
  
  ClickYes(response) {
    this.dialogRef.close(response); 
    clearInterval(this.interval);
  }

  ClickNo(response){
    this.dialogRef.close(response);
    sessionStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/auth/login']);
    // sessionStorage.removeItem("userToken");
    // sessionStorage.removeItem("permissions");
    // sessionStorage.removeItem("databaseId");
    // sessionStorage.removeItem("organizationID");
    // sessionStorage.removeItem("profileImagePath");
    // sessionStorage.removeItem("moduleName");
    // sessionStorage.removeItem("localFiltersContact");
    // sessionStorage.removeItem("localFiltersCompany");
    // sessionStorage.removeItem("localFilters");
    // sessionStorage.removeItem("folderAccess");
    // sessionStorage.removeItem("transactionID");
    // sessionStorage.removeItem("HeaderModuleName");
    // sessionStorage.removeItem("DashboardRefresh");
    // sessionStorage.removeItem("ProjectName");
    // sessionStorage.removeItem("projectID");
    // sessionStorage.removeItem("FolderOpenId");    
    // sessionStorage.removeItem("type");
    
     

   // this.commonService.logoutUser();
  }

  
}
